module.exports = __webpack_public_path__ + "img/2-7-mandalay-bay.5e7831d8.jpg";